export function getEncodedUrlForVroom(location: string): string {
    const base64Value = btoa(location);
    return (
        'u!' +
        base64Value
            .replace(/=+$/, '')
            .replace('/', '_')
            .replace('+', '-')
    );
}
